import {
  KB_TREE_REQUEST,
  KB_TREE_SUCCESS,
  KB_TREE_FAILURE,
  KB_ARTICLE_REQUEST,
  KB_ARTICLE_SUCCESS,
  KB_ARTICLE_FAILURE,
  KB_ARTICLE_CLEAR,
  KB_SEARCH_REQUEST,
  KB_SEARCH_SUCCESS,
  KB_SEARCH_FAILURE,
  KB_SEARCH_CLEAR,
  KB_PUBLIC_TREE_REQUEST,
  KB_PUBLIC_TREE_SUCCESS,
  KB_PUBLIC_TREE_FAILURE,
  KB_PUBLIC_ARTICLE_REQUEST,
  KB_PUBLIC_ARTICLE_SUCCESS,
  KB_PUBLIC_ARTICLE_FAILURE,
  KB_PUBLIC_ARTICLE_CLEAR,
} from "../actions/kbActions"

const initialState = {
  tree: [],
  treeLoading: false,
  treeError: null,
  currentArticle: null,
  articleLoading: false,
  articleError: null,
  // Slug of the most recently REQUESTED article — SUCCESS/FAILURE for any
  // other slug are stale (out-of-order responses) and ignored.
  articleSlug: null,
  searchResults: [],
  searchLoading: false,
  searchError: null,
  publicTree: [],
  publicTreeLoading: false,
  publicTreeError: null,
  publicArticle: null,
  publicArticleLoading: false,
  publicArticleError: null,
  publicArticleSlug: null,
}

const handlers = {
  [KB_TREE_REQUEST]: (state) => ({
    ...state,
    treeLoading: true,
    treeError: null,
  }),
  [KB_TREE_SUCCESS]: (state, action) => ({
    ...state,
    treeLoading: false,
    tree: action.payload || [],
  }),
  [KB_TREE_FAILURE]: (state, action) => ({
    ...state,
    treeLoading: false,
    treeError: action.payload,
  }),
  [KB_ARTICLE_REQUEST]: (state, action) => ({
    ...state,
    articleLoading: true,
    articleError: null,
    currentArticle: null,
    articleSlug: action.slug ?? state.articleSlug,
  }),
  [KB_ARTICLE_SUCCESS]: (state, action) => {
    if (action.slug && action.slug !== state.articleSlug) return state
    return {
      ...state,
      articleLoading: false,
      currentArticle: action.payload || null,
    }
  },
  [KB_ARTICLE_FAILURE]: (state, action) => {
    if (action.slug && action.slug !== state.articleSlug) return state
    return {
      ...state,
      articleLoading: false,
      articleError: action.payload,
    }
  },
  [KB_ARTICLE_CLEAR]: (state) => {
    if (!state.currentArticle && !state.articleError && !state.articleSlug) {
      return state
    }
    return {
      ...state,
      currentArticle: null,
      articleError: null,
      articleSlug: null,
    }
  },
  [KB_SEARCH_REQUEST]: (state) => ({
    ...state,
    searchLoading: true,
    searchError: null,
  }),
  [KB_SEARCH_SUCCESS]: (state, action) => ({
    ...state,
    searchLoading: false,
    searchResults: action.payload || [],
  }),
  [KB_SEARCH_FAILURE]: (state, action) => ({
    ...state,
    searchLoading: false,
    searchError: action.payload,
  }),
  [KB_SEARCH_CLEAR]: (state) => ({
    ...state,
    searchResults: [],
    searchError: null,
  }),
  [KB_PUBLIC_TREE_REQUEST]: (state) => ({
    ...state,
    publicTreeLoading: true,
    publicTreeError: null,
  }),
  [KB_PUBLIC_TREE_SUCCESS]: (state, action) => ({
    ...state,
    publicTreeLoading: false,
    publicTree: action.payload || [],
  }),
  [KB_PUBLIC_TREE_FAILURE]: (state, action) => ({
    ...state,
    publicTreeLoading: false,
    publicTreeError: action.payload,
  }),
  [KB_PUBLIC_ARTICLE_REQUEST]: (state, action) => ({
    ...state,
    publicArticleLoading: true,
    publicArticleError: null,
    publicArticle: null,
    publicArticleSlug: action.slug ?? state.publicArticleSlug,
  }),
  [KB_PUBLIC_ARTICLE_SUCCESS]: (state, action) => {
    if (action.slug && action.slug !== state.publicArticleSlug) return state
    return {
      ...state,
      publicArticleLoading: false,
      publicArticle: action.payload || null,
    }
  },
  [KB_PUBLIC_ARTICLE_FAILURE]: (state, action) => {
    if (action.slug && action.slug !== state.publicArticleSlug) return state
    return {
      ...state,
      publicArticleLoading: false,
      publicArticleError: action.payload,
    }
  },
  [KB_PUBLIC_ARTICLE_CLEAR]: (state) => {
    if (
      !state.publicArticle &&
      !state.publicArticleError &&
      !state.publicArticleSlug
    ) {
      return state
    }
    return {
      ...state,
      publicArticle: null,
      publicArticleError: null,
      publicArticleSlug: null,
    }
  },
}

const kbReducer = (state = initialState, action) => {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}

export default kbReducer
